import { render } from "./EdgeHeader.vue?vue&type=template&id=c34c7e82"
import script from "./EdgeHeader.vue?vue&type=script&lang=js"
export * from "./EdgeHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/EdgeHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c34c7e82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c34c7e82', __exports__)) {
    api.reload('c34c7e82', __exports__)
  }
  
  module.hot.accept("./EdgeHeader.vue?vue&type=template&id=c34c7e82", () => {
    api.rerender('c34c7e82', render)
  })

}


export default __exports__